import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import CoursesComp from './CoursesComp'

function Courses() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <CoursesComp/>      
        </div>
    </div>
  )
}

export default Courses